import i18next from 'i18next';
export const validatePasswordComparisonI18n = (first, second) => (first || second) && first !== second && i18next.t('validation:compareTwoPasswords');
export default validatePasswordComparisonI18n;
